import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { FormWrapperInterface } from "../types/formWrapper.interface"
import { FormWrapperComponentsInterface } from "../types/formWrapperComponents.interface"

export class FormWrapper extends Component<
    FormWrapperInterface,
    FormWrapperComponentsInterface
> {
    constructor(
        props: FormWrapperInterface,
        childComponents: FormWrapperComponentsInterface
    ) {
        super(props, childComponents)
    }

    private setShadow(shadow?: string): void {
        if (shadow) {
            this.element?.style.setProperty("box-shadow", shadow)
        }
    }

    override show() {
        return
    }

    private setExtarnalWrapperWidth(width?: string) {
        if (width) {
            this.element?.style.setProperty("width", width)
        }
    }

    private setMarginTop(margin?: string) {
        if (margin) {
            this.element?.style.setProperty("margin-top", margin)
            this.element?.style.setProperty("padding-top", "0")
        }
    }

    @handleComponentError("FormWrapper")
    render(): void {
        this.setBorder(this.props?.boxBorder)
        this.setShadow(this.props?.boxShadow)
        this.setBackgroundColor(this.props?.backgroundColor)
        this.setExtarnalWrapperWidth(this.props?.width)
        this.setMarginTop(this.props.marginTop)

        super.render()
    }
}
